// cache-bust: v20260629-fix-qcore-mock
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import './index.css';

// FORCE NEW BUILD HASH - remove after first deploy
window.__WXB_BUILD_HASH__ = '20260629006';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider locale={zhCN} theme={{
    token: {
      colorPrimary: '#1677ff',
      borderRadius: 6,
    },
  }}>
    <BrowserRouter basename="/wxb">
      <App />
    </BrowserRouter>
  </ConfigProvider>
);
